import { render, staticRenderFns } from "./c_hot_menu.vue?vue&type=template&id=5334c2f4&scoped=true"
import script from "./c_hot_menu.vue?vue&type=script&lang=js"
export * from "./c_hot_menu.vue?vue&type=script&lang=js"
import style0 from "./c_hot_menu.vue?vue&type=style&index=0&id=5334c2f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334c2f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5334c2f4')) {
      api.createRecord('5334c2f4', component.options)
    } else {
      api.reload('5334c2f4', component.options)
    }
    module.hot.accept("./c_hot_menu.vue?vue&type=template&id=5334c2f4&scoped=true", function () {
      api.rerender('5334c2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_hot_menu.vue"
export default component.exports